import { SxProps, Theme } from '@mui/material';

export const successAlertStyles = (theme: Theme): SxProps<Theme> => ({
  mb: 2,
  backgroundColor: theme.palette.success.light + '20',
});

export const noIncidentsBoxStyles = (theme: Theme): SxProps<Theme> => ({
  height: 200,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.success.light + '10',
  borderRadius: 2,
  border: `2px solid ${theme.palette.success.main}`,
});

export const warningAlertStyles = (theme: Theme): SxProps<Theme> => ({
  mb: 2,
  backgroundColor: theme.palette.warning.light + '20',
});
